import CircularProgress from '@/components/CircularProgress';
import CheckCircle from '@/components/Icons/CheckCircle';
import { TD } from '@/components/DesignLibrary/Table';

export type Props = {
  type: 'progress';
  progress: number;
};

const ProgressCell: React.FC<Props> = ({ progress }) => (
  <TD>
    {progress === 100 ? <CheckCircle color="var(--color-success)" weight="fill" size={16} /> : <CircularProgress size={16} progress={progress} />}
  </TD>
);

export default ProgressCell;
